import { Pipe, PipeTransform } from '@angular/core';
import { formatUsd } from '../formatting/usd-currency';

@Pipe({ name: 'usdCurrency', standalone: true, pure: true })
export class UsdCurrencyPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    return formatUsd(value);
  }
}
